// 使用 element-china-area-data 库提供完整的省市区三级数据
import { regionData, CodeToText } from 'element-china-area-data'

// 将 element-china-area-data 的数据转换为我们需要的格式
// regionData 使用区划代码作为 value，我们需要转换为使用名称
const convertRegionData = (data) => {
  return data.map(province => {
    const provinceObj = {
      value: province.label,
      label: province.label,
      children: []
    };
    
    if (province.children && province.children.length > 0) {
      provinceObj.children = province.children.map(city => {
        const cityObj = {
          value: city.label,
          label: city.label,
          children: []
        };
        
        if (city.children && city.children.length > 0) {
          cityObj.children = city.children.map(district => ({
            value: district.label,
            label: district.label
          }));
        }
        
        return cityObj;
      });
    }
    
    return provinceObj;
  });
};

// 中国省市区三级数据（使用 element-china-area-data）
const chinaProvinces = convertRegionData(regionData);

// 美国州-城市数据
const usaStates = [
  {
    value: '加利福尼亚州',
    label: '加利福尼亚州',
    children: [
      { value: '洛杉矶', label: '洛杉矶' },
      { value: '旧金山', label: '旧金山' },
      { value: '圣地亚哥', label: '圣地亚哥' },
      { value: '圣何塞', label: '圣何塞' },
      { value: '萨克拉门托', label: '萨克拉门托' }
    ]
  },
  {
    value: '纽约州',
    label: '纽约州',
    children: [
      { value: '纽约市', label: '纽约市' },
      { value: '布法罗', label: '布法罗' },
      { value: '罗切斯特', label: '罗切斯特' },
      { value: '扬克斯', label: '扬克斯' }
    ]
  },
  {
    value: '德克萨斯州',
    label: '德克萨斯州',
    children: [
      { value: '休斯顿', label: '休斯顿' },
      { value: '圣安东尼奥', label: '圣安东尼奥' },
      { value: '达拉斯', label: '达拉斯' },
      { value: '奥斯汀', label: '奥斯汀' }
    ]
  },
  {
    value: '佛罗里达州',
    label: '佛罗里达州',
    children: [
      { value: '迈阿密', label: '迈阿密' },
      { value: '奥兰多', label: '奥兰多' },
      { value: '坦帕', label: '坦帕' },
      { value: '杰克逊维尔', label: '杰克逊维尔' }
    ]
  },
  {
    value: '伊利诺伊州',
    label: '伊利诺伊州',
    children: [
      { value: '芝加哥', label: '芝加哥' },
      { value: '奥罗拉', label: '奥罗拉' },
      { value: '内珀维尔', label: '内珀维尔' }
    ]
  },
  {
    value: '华盛顿州',
    label: '华盛顿州',
    children: [
      { value: '西雅图', label: '西雅图' },
      { value: '斯波坎', label: '斯波坎' },
      { value: '塔科马', label: '塔科马' }
    ]
  },
  {
    value: '马萨诸塞州',
    label: '马萨诸塞州',
    children: [
      { value: '波士顿', label: '波士顿' },
      { value: '伍斯特', label: '伍斯特' },
      { value: '斯普林菲尔德', label: '斯普林菲尔德' }
    ]
  }
];

// 日本都道府县-城市数据
const japanPrefectures = [
  {
    value: '东京都',
    label: '东京都',
    children: [
      { value: '千代田区', label: '千代田区' },
      { value: '中央区', label: '中央区' },
      { value: '港区', label: '港区' },
      { value: '新宿区', label: '新宿区' },
      { value: '涩谷区', label: '涩谷区' },
      { value: '品川区', label: '品川区' }
    ]
  },
  {
    value: '大阪府',
    label: '大阪府',
    children: [
      { value: '大阪市', label: '大阪市' },
      { value: '堺市', label: '堺市' },
      { value: '东大阪市', label: '东大阪市' },
      { value: '丰中市', label: '丰中市' }
    ]
  },
  {
    value: '京都府',
    label: '京都府',
    children: [
      { value: '京都市', label: '京都市' },
      { value: '宇治市', label: '宇治市' },
      { value: '舞鹤市', label: '舞鹤市' }
    ]
  },
  {
    value: '神奈川县',
    label: '神奈川县',
    children: [
      { value: '横滨市', label: '横滨市' },
      { value: '川崎市', label: '川崎市' },
      { value: '相模原市', label: '相模原市' },
      { value: '藤泽市', label: '藤泽市' }
    ]
  },
  {
    value: '爱知县',
    label: '爱知县',
    children: [
      { value: '名古屋市', label: '名古屋市' },
      { value: '丰田市', label: '丰田市' },
      { value: '冈崎市', label: '冈崎市' }
    ]
  },
  {
    value: '北海道',
    label: '北海道',
    children: [
      { value: '札幌市', label: '札幌市' },
      { value: '函馆市', label: '函馆市' },
      { value: '小樽市', label: '小樽市' },
      { value: '旭川市', label: '旭川市' }
    ]
  },
  {
    value: '福冈县',
    label: '福冈县',
    children: [
      { value: '福冈市', label: '福冈市' },
      { value: '北九州市', label: '北九州市' },
      { value: '久留米市', label: '久留米市' }
    ]
  }
];

// 韩国道-城市数据
const koreaProvinces = [
  {
    value: '首尔特别市',
    label: '首尔特别市',
    children: [
      { value: '钟路区', label: '钟路区' },
      { value: '中区', label: '中区' },
      { value: '江南区', label: '江南区' },
      { value: '瑞草区', label: '瑞草区' },
      { value: '松坡区', label: '松坡区' }
    ]
  },
  {
    value: '釜山广域市',
    label: '釜山广域市',
    children: [
      { value: '中区', label: '中区' },
      { value: '西区', label: '西区' },
      { value: '东区', label: '东区' },
      { value: '海云台区', label: '海云台区' }
    ]
  },
  {
    value: '京畿道',
    label: '京畿道',
    children: [
      { value: '水原市', label: '水原市' },
      { value: '成南市', label: '成南市' },
      { value: '高阳市', label: '高阳市' },
      { value: '龙仁市', label: '龙仁市' }
    ]
  },
  {
    value: '仁川广域市',
    label: '仁川广域市',
    children: [
      { value: '中区', label: '中区' },
      { value: '东区', label: '东区' },
      { value: '南区', label: '南区' }
    ]
  },
  {
    value: '大邱广域市',
    label: '大邱广域市',
    children: [
      { value: '中区', label: '中区' },
      { value: '东区', label: '东区' },
      { value: '西区', label: '西区' }
    ]
  }
];

// 德国州-城市数据
const germanyStates = [
  {
    value: '巴伐利亚州',
    label: '巴伐利亚州',
    children: [
      { value: '慕尼黑', label: '慕尼黑' },
      { value: '纽伦堡', label: '纽伦堡' },
      { value: '奥格斯堡', label: '奥格斯堡' }
    ]
  },
  {
    value: '北莱茵-威斯特法伦州',
    label: '北莱茵-威斯特法伦州',
    children: [
      { value: '科隆', label: '科隆' },
      { value: '杜塞尔多夫', label: '杜塞尔多夫' },
      { value: '多特蒙德', label: '多特蒙德' },
      { value: '埃森', label: '埃森' }
    ]
  },
  {
    value: '巴登-符腾堡州',
    label: '巴登-符腾堡州',
    children: [
      { value: '斯图加特', label: '斯图加特' },
      { value: '曼海姆', label: '曼海姆' },
      { value: '卡尔斯鲁厄', label: '卡尔斯鲁厄' }
    ]
  },
  {
    value: '柏林',
    label: '柏林',
    children: [
      { value: '米特区', label: '米特区' },
      { value: '夏洛滕堡', label: '夏洛滕堡' },
      { value: '克罗伊茨贝格', label: '克罗伊茨贝格' }
    ]
  },
  {
    value: '汉堡',
    label: '汉堡',
    children: [
      { value: '汉堡市中心', label: '汉堡市中心' },
      { value: '阿尔托纳', label: '阿尔托纳' },
      { value: '埃彭多夫', label: '埃彭多夫' }
    ]
  }
];

// 英国地区-城市数据
const ukRegions = [
  {
    value: '英格兰',
    label: '英格兰',
    children: [
      { value: '伦敦', label: '伦敦' },
      { value: '曼彻斯特', label: '曼彻斯特' },
      { value: '伯明翰', label: '伯明翰' },
      { value: '利物浦', label: '利物浦' },
      { value: '利兹', label: '利兹' },
      { value: '谢菲尔德', label: '谢菲尔德' },
      { value: '布里斯托', label: '布里斯托' }
    ]
  },
  {
    value: '苏格兰',
    label: '苏格兰',
    children: [
      { value: '爱丁堡', label: '爱丁堡' },
      { value: '格拉斯哥', label: '格拉斯哥' },
      { value: '阿伯丁', label: '阿伯丁' }
    ]
  },
  {
    value: '威尔士',
    label: '威尔士',
    children: [
      { value: '卡迪夫', label: '卡迪夫' },
      { value: '斯旺西', label: '斯旺西' },
      { value: '纽波特', label: '纽波特' }
    ]
  },
  {
    value: '北爱尔兰',
    label: '北爱尔兰',
    children: [
      { value: '贝尔法斯特', label: '贝尔法斯特' },
      { value: '德里', label: '德里' }
    ]
  }
];

// 法国大区-城市数据
const franceRegions = [
  {
    value: '法兰西岛大区',
    label: '法兰西岛大区',
    children: [
      { value: '巴黎', label: '巴黎' },
      { value: '凡尔赛', label: '凡尔赛' },
      { value: '布洛涅', label: '布洛涅' }
    ]
  },
  {
    value: '普罗旺斯-阿尔卑斯-蓝色海岸大区',
    label: '普罗旺斯大区',
    children: [
      { value: '马赛', label: '马赛' },
      { value: '尼斯', label: '尼斯' },
      { value: '戛纳', label: '戛纳' }
    ]
  },
  {
    value: '奥弗涅-罗讷-阿尔卑斯大区',
    label: '罗讷-阿尔卑斯大区',
    children: [
      { value: '里昂', label: '里昂' },
      { value: '格勒诺布尔', label: '格勒诺布尔' },
      { value: '圣艾蒂安', label: '圣艾蒂安' }
    ]
  },
  {
    value: '新阿基坦大区',
    label: '新阿基坦大区',
    children: [
      { value: '波尔多', label: '波尔多' },
      { value: '图卢兹', label: '图卢兹' }
    ]
  }
];

// 加拿大省-城市数据
const canadaProvinces = [
  {
    value: '安大略省',
    label: '安大略省',
    children: [
      { value: '多伦多', label: '多伦多' },
      { value: '渥太华', label: '渥太华' },
      { value: '密西沙加', label: '密西沙加' },
      { value: '汉密尔顿', label: '汉密尔顿' }
    ]
  },
  {
    value: '魁北克省',
    label: '魁北克省',
    children: [
      { value: '蒙特利尔', label: '蒙特利尔' },
      { value: '魁北克市', label: '魁北克市' },
      { value: '拉瓦尔', label: '拉瓦尔' }
    ]
  },
  {
    value: '不列颠哥伦比亚省',
    label: '不列颠哥伦比亚省',
    children: [
      { value: '温哥华', label: '温哥华' },
      { value: '维多利亚', label: '维多利亚' },
      { value: '萨里', label: '萨里' }
    ]
  },
  {
    value: '阿尔伯塔省',
    label: '阿尔伯塔省',
    children: [
      { value: '卡尔加里', label: '卡尔加里' },
      { value: '埃德蒙顿', label: '埃德蒙顿' }
    ]
  }
];

// 澳大利亚州-城市数据
const australiaStates = [
  {
    value: '新南威尔士州',
    label: '新南威尔士州',
    children: [
      { value: '悉尼', label: '悉尼' },
      { value: '纽卡斯尔', label: '纽卡斯尔' },
      { value: '卧龙岗', label: '卧龙岗' }
    ]
  },
  {
    value: '维多利亚州',
    label: '维多利亚州',
    children: [
      { value: '墨尔本', label: '墨尔本' },
      { value: '吉朗', label: '吉朗' },
      { value: '巴拉瑞特', label: '巴拉瑞特' }
    ]
  },
  {
    value: '昆士兰州',
    label: '昆士兰州',
    children: [
      { value: '布里斯班', label: '布里斯班' },
      { value: '黄金海岸', label: '黄金海岸' },
      { value: '凯恩斯', label: '凯恩斯' }
    ]
  },
  {
    value: '西澳大利亚州',
    label: '西澳大利亚州',
    children: [
      { value: '珀斯', label: '珀斯' },
      { value: '弗里曼特尔', label: '弗里曼特尔' }
    ]
  },
  {
    value: '南澳大利亚州',
    label: '南澳大利亚州',
    children: [
      { value: '阿德莱德', label: '阿德莱德' }
    ]
  }
];

// 印度邦-城市数据
const indiaStates = [
  {
    value: '马哈拉施特拉邦',
    label: '马哈拉施特拉邦',
    children: [
      { value: '孟买', label: '孟买' },
      { value: '浦那', label: '浦那' },
      { value: '那格浦尔', label: '那格浦尔' }
    ]
  },
  {
    value: '德里',
    label: '德里',
    children: [
      { value: '新德里', label: '新德里' },
      { value: '老德里', label: '老德里' }
    ]
  },
  {
    value: '卡纳塔克邦',
    label: '卡纳塔克邦',
    children: [
      { value: '班加罗尔', label: '班加罗尔' },
      { value: '迈索尔', label: '迈索尔' }
    ]
  },
  {
    value: '泰米尔纳德邦',
    label: '泰米尔纳德邦',
    children: [
      { value: '金奈', label: '金奈' },
      { value: '哥印拜陀', label: '哥印拜陀' }
    ]
  },
  {
    value: '古吉拉特邦',
    label: '古吉拉特邦',
    children: [
      { value: '艾哈迈达巴德', label: '艾哈迈达巴德' },
      { value: '苏拉特', label: '苏拉特' }
    ]
  }
];

// 新加坡区域数据（新加坡较小，按区域划分）
const singaporeRegions = [
  {
    value: '中区',
    label: '中区',
    children: [
      { value: '市中心', label: '市中心' },
      { value: '乌节路', label: '乌节路' },
      { value: '滨海湾', label: '滨海湾' }
    ]
  },
  {
    value: '东北区',
    label: '东北区',
    children: [
      { value: '后港', label: '后港' },
      { value: '盛港', label: '盛港' },
      { value: '榜鹅', label: '榜鹅' }
    ]
  },
  {
    value: '西部区',
    label: '西部区',
    children: [
      { value: '裕廊', label: '裕廊' },
      { value: '文礼', label: '文礼' },
      { value: '蔡厝港', label: '蔡厝港' }
    ]
  },
  {
    value: '东南区',
    label: '东南区',
    children: [
      { value: '樟宜', label: '樟宜' },
      { value: '淡滨尼', label: '淡滨尼' },
      { value: '巴西立', label: '巴西立' }
    ]
  }
];

// 马来西亚州-城市数据
const malaysiaStates = [
  {
    value: '吉隆坡联邦直辖区',
    label: '吉隆坡',
    children: [
      { value: '市中心', label: '市中心' },
      { value: '武吉免登', label: '武吉免登' },
      { value: '蕉赖', label: '蕉赖' }
    ]
  },
  {
    value: '雪兰莪州',
    label: '雪兰莪州',
    children: [
      { value: '八打灵再也', label: '八打灵再也' },
      { value: '莎阿南', label: '莎阿南' },
      { value: '梳邦再也', label: '梳邦再也' }
    ]
  },
  {
    value: '槟城',
    label: '槟城',
    children: [
      { value: '乔治市', label: '乔治市' },
      { value: '峇六拜', label: '峇六拜' }
    ]
  },
  {
    value: '柔佛州',
    label: '柔佛州',
    children: [
      { value: '新山', label: '新山' },
      { value: '古来', label: '古来' }
    ]
  }
];

// 泰国府-城市数据
const thailandProvinces = [
  {
    value: '曼谷',
    label: '曼谷',
    children: [
      { value: '挽叻区', label: '挽叻区' },
      { value: '巴吞旺区', label: '巴吞旺区' },
      { value: '素坤逸区', label: '素坤逸区' }
    ]
  },
  {
    value: '清迈府',
    label: '清迈府',
    children: [
      { value: '清迈市', label: '清迈市' },
      { value: '湄林', label: '湄林' }
    ]
  },
  {
    value: '普吉府',
    label: '普吉府',
    children: [
      { value: '普吉市', label: '普吉市' },
      { value: '卡图', label: '卡图' },
      { value: '他朗', label: '他朗' }
    ]
  },
  {
    value: '春武里府',
    label: '春武里府',
    children: [
      { value: '芭提雅', label: '芭提雅' },
      { value: '是拉差', label: '是拉差' }
    ]
  }
];

// 国家/地区数据
export const countryList = [
  { value: '中国', label: '中国' },
  { value: '美国', label: '美国' },
  { value: '日本', label: '日本' },
  { value: '韩国', label: '韩国' },
  { value: '德国', label: '德国' },
  { value: '英国', label: '英国' },
  { value: '法国', label: '法国' },
  { value: '意大利', label: '意大利' },
  { value: '西班牙', label: '西班牙' },
  { value: '加拿大', label: '加拿大' },
  { value: '澳大利亚', label: '澳大利亚' },
  { value: '新西兰', label: '新西兰' },
  { value: '新加坡', label: '新加坡' },
  { value: '马来西亚', label: '马来西亚' },
  { value: '泰国', label: '泰国' },
  { value: '印度', label: '印度' },
  { value: '印度尼西亚', label: '印度尼西亚' },
  { value: '越南', label: '越南' },
  { value: '菲律宾', label: '菲律宾' },
  { value: '俄罗斯', label: '俄罗斯' },
  { value: '巴西', label: '巴西' },
  { value: '墨西哥', label: '墨西哥' },
  { value: '阿根廷', label: '阿根廷' },
  { value: '南非', label: '南非' },
  { value: '埃及', label: '埃及' },
  { value: '沙特阿拉伯', label: '沙特阿拉伯' },
  { value: '阿联酋', label: '阿联酋' },
  { value: '土耳其', label: '土耳其' },
  { value: '其他', label: '其他' }
];

// 各国省市数据映射表
export const countryRegionMap = {
  '中国': chinaProvinces,
  '美国': usaStates,
  '日本': japanPrefectures,
  '韩国': koreaProvinces,
  '德国': germanyStates,
  '英国': ukRegions,
  '法国': franceRegions,
  '加拿大': canadaProvinces,
  '澳大利亚': australiaStates,
  '印度': indiaStates,
  '新加坡': singaporeRegions,
  '马来西亚': malaysiaStates,
  '泰国': thailandProvinces
};

// 默认导出中国数据（向后兼容）
export const provinceOptions = chinaProvinces;
